import TreeView from "@material-ui/lab/TreeView";
import TreeItem, {TreeItemProps} from "@material-ui/lab/TreeItem";
import * as React from "react";
import {useEffect} from "react";
import {createStyles, Theme, Typography} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FolderIcon from '@material-ui/icons/Folder';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {DocumentStructureItem, DocumentStructureItemType} from "./definitions/Structure";

import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {TabsService} from "../TabsService";
import {TabTypes} from "../Tab";

import {Document} from "../../models/Document";
import {Folder} from "../../models/Folder";
import _ = require('lodash');
import {BaseModel} from "../../models/BaseModel";
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails";
import {LookupDataRow} from "../../services/LookupDataRow";


// Based on https://material-ui.com/components/tree-view/

declare module 'csstype' {
	interface Properties {
		'--tree-view-color'?: string;
		'--tree-view-bg-color'?: string;
	}
}

const useTreeItemStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			color: theme.palette.text.secondary,
			'&:hover > $content': {
				backgroundColor: theme.palette.action.hover,
			},
			'&:focus > $content, &$selected > $content': {
				// backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
				// color: 'var(--tree-view-color)',
			},
			'&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
				backgroundColor: 'transparent',
			},
		},
		content: {
			color: theme.palette.text.secondary,
			borderTopRightRadius: theme.spacing(2),
			borderBottomRightRadius: theme.spacing(2),
			paddingRight: theme.spacing(1),
			fontWeight: theme.typography.fontWeightMedium,
			'$expanded > &': {
				fontWeight: theme.typography.fontWeightRegular,
			},
		},
		group: {
			marginLeft: theme.spacing(2)
		},
		expanded: {},
		selected: {},
		label: {
			fontWeight: 'inherit',
			color: 'inherit',
		},
		labelRoot: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(0.5, 0),
		},
		labelIcon: {
			marginRight: theme.spacing(1),
		},
		labelText: {
			fontWeight: 'inherit',
			flexGrow: 1,
		},
	}),
);

type StyledTreeItemProps = TreeItemProps & {
	item: DocumentStructureItem
};

const StyledTreeItem = (props: StyledTreeItemProps) => {
	const classes = useTreeItemStyles();
	const {item, nodeId, children} = props;

	return (
		<TreeItem
			nodeId = {nodeId}
			key = {nodeId}
			label={
				<div className={classes.labelRoot}>
					{itemIcon(item.type, classes)}
					<Typography variant="body2" className={classes.labelText}>
						{item.title}
					</Typography>
					<Typography variant="caption" color="inherit">
						{item.info}
					</Typography>
					{item.allowFolders &&
						<IconButton color="primary" aria-label="upload picture" component="span" size={"small"}
								onClick={(event: any) => {
									event.preventDefault()
									TabsService.createTab('New folder', TabTypes.FOLDERS_NEW, { parentId: item.id, id: null, type: item.folderStructure.type })
								}}>
							<CreateNewFolderIcon/>
						</IconButton>
					}
					{item.allowDocuments &&
					<IconButton color="primary" aria-label="upload picture" component="span" size={"small"}
								onClick={(event: any) => {
									event.preventDefault()
									// todo: show popup if multiple options exists
									if (item.allowedDocuments && item.allowedDocuments.length) {
										let documentType = item.allowedDocuments[0]
										TabsService.createTab(`${item.title}`, TabTypes.DOCUMENT_NEW, { parentId: item.id, id: null, type: documentType })
									}
								}}>
						<AddCircleOutlineIcon/>
					</IconButton>
					}
					{item.type == DocumentStructureItemType.Document &&
					<IconButton color="primary" aria-label="new document" component="span" size={"small"}
								onClick={(event: any) => {
									event.preventDefault()
									TabsService.createTab(`${item.title}`, TabTypes.DOCUMENT_NEW, { id: item.id, type: item.type })
								}}>
						<OpenInNewIcon/>
					</IconButton>
					}
					{item.type == DocumentStructureItemType.Folder &&
					<IconButton color="primary" aria-label="new folder" component="span" size={"small"}
								onClick={(event: any) => {
									event.preventDefault()
									TabsService.createTab('New folder', TabTypes.FOLDERS_NEW, { id: item.id, type: item.type })
								}}>
						<OpenInNewIcon/>
					</IconButton>
					}
				</div>
			}
			classes={{
				root: classes.root,
				content: classes.content,
				expanded: classes.expanded,
				selected: classes.selected,
				group: classes.group,
				label: classes.label,
			}}
			children={children}
		/>
	);
}

const itemIcon = (itemType: DocumentStructureItemType, classes: any) => {
	switch (itemType) {
		case DocumentStructureItemType.Folder:
			return <FolderIcon color="inherit" className={classes.labelIcon} />
		case DocumentStructureItemType.Document:
			return <DescriptionIcon color="inherit" className={classes.labelIcon} />
	}
	return <FolderIcon color="inherit" className={classes.labelIcon} />
}

const useStyles = makeStyles(
	createStyles({
		root: {
			height: 264,
			flexGrow: 1,
			maxWidth: 400,
		},
	}),
);

const generateTreeItems = (item: DocumentStructureItem, result: JSX.Element[], folders: Folder[], documents: Document[], lookupData: (lookupEntity: LookupEntities) => LookupDataRow[], depth: number, test: string) => {

	if (depth > 10) return

	console.log(`${depth} ${test}`)
	console.log(item)

	if (item.title == 'Direktor IT' || item.title == 'CTO' || item.title == 'HR' || item.title == 'IT department') {
		console.log(1)
	}

	let children: JSX.Element[] = []
	if (!item.children) {
		item.children = []
	}

	let newChildren: DocumentStructureItem[] = []
	for (let curItem of item.children) {
		if (curItem.type === DocumentStructureItemType.Enitity && lookupData) {
			let data = lookupData(curItem.entity)
			if (data) {
				for (let element of data) {
					let newItem = {
						id: element.value,
						type: DocumentStructureItemType.Static,
						title: element.label,
						children: _.cloneDeep(curItem.children)
					}
					if (curItem.entityParentId && element.data) {
						if (element.data[curItem.entityParentId] == item.id) {
							newChildren.push(newItem)
						}
					} else {
						newChildren.push(newItem)
					}
				}
			}
		}
	}

	for (let i = item.children.length - 1; i >= 0; --i) {
		if (item.children[i].type === DocumentStructureItemType.Enitity) {
			item.children.splice(i, 1);
		}
	}

	for (let newChild of newChildren) {
		item.children.push(newChild)
	}

	for (let folder of folders) {
		if (folder.parentId == item.id) {
			let newItem = {
				id: folder.id,
				type: DocumentStructureItemType.Folder,
				title: Folder.getTitle(folder),
				info: folder.info,
				allowFolders: false,
				allowDocuments: true
			}
			item.children.push(newItem)
		}
	}

	for (let document of documents) {
		if (document.parentId == item.id) {
			let newItem = {
				id: document.id,
				type: DocumentStructureItemType.Document,
				title: Document.getTitle(document),
				info: document.info,
				allowFolders: false,
				allowDocuments: false
			}
			item.children.push(newItem)
		}
	}

	const itemChildren = item.children
	if (itemChildren) {
		for (let child of itemChildren) {
			if (child.type != DocumentStructureItemType.StaticFolderDef && child.type != DocumentStructureItemType.StaticDocumentDef) {
				generateTreeItems(child, children, folders, documents, lookupData, depth+1, `${test}->${item.title}`)
			}
		}
	}

	if (item.type != DocumentStructureItemType.StaticFolderDef && item.type != DocumentStructureItemType.StaticDocumentDef && item.type != DocumentStructureItemType.Enitity) {
		let element = <StyledTreeItem key={item.id} item={_.cloneDeep(item)} nodeId={item.id}>{children}</StyledTreeItem>
		result.push(element)
	}
}

export type DocumentsStructureTreeProps = {
	structure: DocumentStructureItem
	documents: Document[]
	setExpanded: (nodeIds: any) => any
	expandedNodeIds: string[]
	folders: Folder[]
	lookupData?: (lookupEntity: LookupEntities) => LookupDataRow[]
}

export const DocumentsStructureTree = (props: DocumentsStructureTreeProps) => {

	const classes = useStyles();
	const [expanded, setExpanded] = React.useState<string[]>([]);
	const [selected, setSelected] = React.useState<string[]>([]);

	useEffect(() => {
		if (props.expandedNodeIds) setExpanded(props.expandedNodeIds)
	}, [])

	const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
		setExpanded(nodeIds);
		props.setExpanded(nodeIds)
	};

	const handleSelect = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
		setSelected(nodeIds);
	};

	let structure: JSX.Element[] = []
	console.log('tree start')
	const item = _.cloneDeep(props.structure)
	generateTreeItems(item, structure, props.folders, props.documents, props.lookupData, 0, '')
	console.log('tree end')

	return <TreeView
		expanded={expanded}
		selected={selected}
		onNodeToggle={handleToggle}
		onNodeSelect={handleSelect}
		className={classes.root}
		defaultExpanded={['3']}
		defaultCollapseIcon={<ArrowDropDownIcon />}
		defaultExpandIcon={<ArrowRightIcon />}
		defaultEndIcon={<div style={{ width: 24 }} />}>
		{structure}
	</TreeView>
}
